<template>
  <el-dialog title="安全环保计划详情" :visible.sync="open" width="700px" append-to-body>
    <el-descriptions :column="2" border>
      <el-descriptions-item label="时间">
        {{ detail.time }}
      </el-descriptions-item>
      <el-descriptions-item label="状态">
        <el-tag v-if="detail.status === 'planning'" type="info">计划中</el-tag>
        <el-tag v-else-if="detail.status === 'executing'" type="warning">执行中</el-tag>
        <el-tag v-else-if="detail.status === 'completed'" type="success">已完成</el-tag>
        <el-tag v-else-if="detail.status === 'paused'" type="danger">已暂停</el-tag>
        <span v-else>{{ detail.status }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="创建人">
        {{ detail.createByUserName }}
      </el-descriptions-item>
      <el-descriptions-item label="创建时间">
        {{ detail.createTime }}
      </el-descriptions-item>
      <el-descriptions-item label="更新人">
        {{ detail.updateByUserName }}
      </el-descriptions-item>
      <el-descriptions-item label="更新时间">
        {{ detail.updateTime }}
      </el-descriptions-item>
      <el-descriptions-item label="内容" :span="2">
        <div style="white-space: pre-wrap; word-break: break-all;">
          {{ detail.content }}
        </div>
      </el-descriptions-item>
    </el-descriptions>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="open = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {querySafetyPlanDetail} from "@/api/crm/safetyPlan";

export default {
  name: "SafetyPlanDetailDialog",
  data() {
    return {
      // 是否显示弹出层
      open: false,
      // 详情数据
      detail: {}
    };
  },
  methods: {
    // 打开对话框
    openDialog(id) {
      this.open = true;
      this.detail = {};
      this.getDetail(id);
    },
    
    // 获取详情
    getDetail(id) {
      querySafetyPlanDetail({id}).then(response => {
        this.detail = response.data || {};
      });
    }
  }
};
</script>